import { FormControlLabel, FormControlLabelProps } from "@material-ui/core";
import styled from "styled-components";

const FilterLabel = styled(FormControlLabel)<FormControlLabelProps>`
  & .MuiTypography-root {
    font-size: 14px;
  }
`;
export default FilterLabel;
